<template>
  <!--  <div>-->
  <!--    <meta name="referrer" content="never" />-->
  <iframe
    frameborder="0"
    class="ui-editor"
    ref="ui-editor"
    rel="noreferrer"
    referrerpolicy="no-referrer"
    placeholder="placeholder"
  ></iframe>
  <!--  </div>-->
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      html: '',
    };
  },
  watch: {
    value(v) {
      // console.log('!');
      if (v !== this.html) {
        // this.$refs['ui-editor'].innerHTML = v;
        // console.log(v);
        if (v) {
          this.$refs['ui-editor'].contentWindow.document.write(v);
        } else {
          this.$refs['ui-editor'].contentWindow.document.write(`<body></body>`);
        }
        this.$refs['ui-editor'].contentWindow.document.body.contentEditable = 'true';
        this.$refs['ui-editor'].contentWindow.document.body.addEventListener('paste', this.paste);
        this.$refs['ui-editor'].contentWindow.document.close();
        this.html = v;
      }
    },
  },
  mounted() {
    const v = this.value;
    if (v) {
      this.$refs['ui-editor'].contentWindow.document.write(v);
    } else {
      this.$refs['ui-editor'].contentWindow.document.write(`<body></body>`);
    }
    this.$refs['ui-editor'].contentWindow.document.body.contentEditable = 'true';
    this.$refs['ui-editor'].contentWindow.document.body.addEventListener('paste', this.paste);
    // this.$refs['ui-editor'].contentWindow.document.body.addEventListener('input', this.input);
    this.$refs['ui-editor'].contentWindow.document.close();
    this.html = v;
  },
  methods: {
    paste(e) {
      // console.log('?');
      // e.preventDefault();
      const html = e.clipboardData.getData('text/html');
      // this.$refs['ui-editor'].srcdoc += html;
      this.html = html;
      setImmediate(() => {
        this.input();
      });
    },
    input() {
      // console.log('??');
      this.$emit('input', this.$refs['ui-editor'].contentWindow.document.body.innerHTML);
    },
    out() {},
  },
};
</script>
<style lang="scss" scoped>
.ui-editor {
  margin: 0 auto;
  padding: 15px;
  width: 100%;
  /*min-height: 600px;*/
  height: 600px;
  box-shadow: inset 0 0 12px rgba(63, 70, 82, 0.5);
  background-color: #fff;
  overflow: auto;
  user-select: all;
  outline: none;
  &:hover {
    outline: 1px solid #2f96ff;
  }
}
.ui-editor:empty:before {
  content: '请粘贴预览文本, 外部编辑器图片大小不能超过1M';
  color: gray;
}
.ui-editor:focus:before {
  content: none;
}
</style>
